export default "__VITE_ASSET__BbNtA5gM__"